module.exports = __webpack_public_path__ + "img/business_receive_04.png";